import {NgModule} from '@angular/core';
// TODO Dependency
import {TicketTypePage} from "./page/overview/ticket-type/ticket-type.page";
import {TicketComponent} from "./component/protected-components/ticket/ticket.component";
// TODO Dependency
import {UmModule} from "../um/um.module";
// TODO Dependency
import {DmModule} from '../dm/dm.module';
import {HistoryComponent} from './component/protected-components/history/history.component';
// TODO Dependency
import {
    TicketHistoryComponent
} from './component/protected-components/ticket-comment-history/ticket-comment-history.component';
import {TmObjectTicketsComponent} from "./component/protected-components/object-tickets/tm-object-tickets.component";
import {TmActiveTicketComponent} from "./component/protected-components/active-ticket/tm-active-ticket.component";
import {MyTicketsComponent} from "./component/protected-components/my-tickets/my-tickets.component";
import {
    TmTicketWfProcessStepActivityComponent
} from "./component/protected-components/wf/tm-ticket-wf-process-step-activity/tm-ticket-wf-process-step-activity.component";
import {
    TmTicketAppointmentInlineComponent
} from "./component/protected-components/tm-ticket-appointment-inline-component/tm-ticket-appointment-inline-component";
import {
    MvsCreateObjectTicketComponent
} from "./component/protected-components/create-object-ticket/mvs-create-object-ticket.component";
// TODO Dependency
import {NsModule} from "../ns/ns.module";
import {
    TmTicketSelectPredefinedTaskComponent
} from "./component/protected-components/ticket/ticket-components/tm-ticket-select-predefined-task/tm-ticket-select-predefined-task.component";
import {
    TmTicketCompletionComponent
} from "./component/protected-components/ticket/ticket-components/tm-ticket-completion/tm-ticket-completion.component";
import {
    TmTicketAttachmentComponent
} from "./component/protected-components/ticket/ticket-components/tm-ticket-attachement/tm-ticket-attachment.component";
import {
    TmTicketCommentHistoryComponent
} from "./component/protected-components/ticket/ticket-components/tm-ticket-comment-history/tm-ticket-comment-history.component";
import {
    TmTicketSubNavigationTasksComponent,
} from "./component/protected-components/ticket/ticket-components/tm-ticket-sub-navigation-tasks/tm-ticket-sub-navigation-tasks.component";
import {
    TmTicketLandingComponentsComponent
} from "./component/protected-components/ticket/ticket-components/tm-ticket-landing-components/tm-ticket-landing-components.component";
import {
    TmTicketActionsComponent
} from "./component/protected-components/ticket/ticket-components/tm-ticket-actions/tm-ticket-actions.component";
import {
    CreateTmTicketActionsComponent
} from "./component/protected-components/ticket/ticket-components/create-tm-ticket-actions/create-tm-ticket-actions.component";
import {
    TicketTypeObjectComponent
} from "./component/protected-components/object-component/ticket-type-object-component/ticket-type-object.component";
// TODO Dependency
import {WfModule} from "../wf/wf.module";
import {TicketOverviewPage} from "./page/ticket-overview-page/ticket-overview.page";
// TODO Dependency
// TODO Dependency
import {
    TmStatisticsComponent
} from "./page/ticket-overview-page/components/statisticsComponent/tm-statistics.component";
import {TmKpiComponent} from "./page/ticket-overview-page/components/kpiComponent/tm-kpi.component";

import {
    TicketQuickCreateComponent
} from "./component/protected-components/ticket-quick-create/ticket-quick-create.component";
import {
    TicketCompleteFormComponent
} from "./component/protected-components/ticket-complete-form/ticket-complete-form.component";
import {
    ObjectTicketGroupFilterComponent
} from "./component/protected-components/object-ticket-group-filter/object-ticket-group-filter.component";
import {
    TicketManagementComponent
} from "./component/protected-components/ticket-management/ticket-management.component";
import {
    TicketFilterGroupListComponent
} from "./component/protected-components/ticket-management/components/ticket-filter-group-list-component/ticket-filter-group-list.component";
import {
    TicketTypeObjectFullComponent
} from "./component/protected-components/object-component/ticket-type-object-component/view/ticket-type-object-component-full/ticket-type-object-full.component";
import {
    TicketTypeObjectSideComponent
} from "./component/protected-components/object-component/ticket-type-object-component/view/ticket-type-object-component-side/ticket-type-object-side.component";


import {
    TicketTypeObjectBaseComponent
} from "./component/protected-components/object-component/ticket-type-object-component/view/ticket-type-object-base.component";
import {
    TmTicketCustomerContactComponent
} from "./component/protected-components/ticket/ticket-components/tm-ticket-customer-contact/tm-ticket-customer-contact.component";
import {
    TicketObjectInlineComponent
} from "./component/protected-components/ticket-object-inline/ticket-object-inline.component";
import {TM_ENTITY_PROVIDER} from "./tm.entity-provider";
import {CoreModule} from "../../core/core.module";
import {DynamicModule} from "../../core/shared/interface/dynamic-module.interface";
import {ModuleRegistryService} from "../../core/shared/interface/module-registration.service";
import {PMessagesComponent} from "../../core/shared/p-messages/p-messages.component";
import {
    TmTicketCreateConsultantComponent
} from "./component/protected-components/ticket/ticket-components/tm-ticket-create/tm-ticket-create-consultant.component";
import {
    TmTicketConsultantComponent
} from "./component/protected-components/ticket/ticket-components/tm-ticket/tm-ticket-consultant.component";
import {TM_TEST_PROVIDERS} from "./test/tm-test-definition";
import {TM_WF_ACTIVITY_PROVIDER} from "./tm-wf-activity.provider";
import {
    TmMyTicketsComponent
} from "./component/protected-components/consultant-component/tm-my-tickets/tm-my-tickets.component";
import {TicketsPage} from "./page/consultant-page/page/tickets-page/tickets.page";
import {TicketCommentPage} from "./page/ticket-comment-page/ticket-comment.page";
import {
    TmConfigCheckResultComponent
} from "./component/protected-components/tm-config-check-result/tm-config-check-result.component";
import {TicketTrashPage} from "./page/ticket-trash-page/ticket-trash.page";


@NgModule({
    imports: [
        CoreModule,
        UmModule,
        DmModule,
        NsModule,
        WfModule,
        PMessagesComponent,
        MvsCreateObjectTicketComponent,
    ],

    declarations: [
        TicketTypePage,
        TicketComponent,
        HistoryComponent,
        TicketHistoryComponent,
        TmObjectTicketsComponent,
        TmActiveTicketComponent,
        MyTicketsComponent,
        TmTicketWfProcessStepActivityComponent,
        TmTicketAppointmentInlineComponent,
        TmTicketSelectPredefinedTaskComponent,
        TmTicketCompletionComponent,
        TmTicketAttachmentComponent,
        TmTicketCommentHistoryComponent,
        TmTicketSubNavigationTasksComponent,
        TmTicketLandingComponentsComponent,
        TicketTypeObjectComponent,
        TmTicketLandingComponentsComponent,
        TmTicketActionsComponent,
        CreateTmTicketActionsComponent,
        TicketOverviewPage,
        TmStatisticsComponent,
        TmKpiComponent,
        TicketQuickCreateComponent,
        TicketCompleteFormComponent,
        ObjectTicketGroupFilterComponent,
        TicketManagementComponent,
        TicketFilterGroupListComponent,
        TicketTypeObjectFullComponent,
        TicketTypeObjectSideComponent,
        TicketTypeObjectBaseComponent,
        TmTicketCustomerContactComponent,
        TicketObjectInlineComponent,
        TmTicketCreateConsultantComponent,
        TmTicketConsultantComponent,
        TmMyTicketsComponent,
        TicketsPage,
        TicketCommentPage,
        TmConfigCheckResultComponent,
        TicketTrashPage,
    ],
    exports: [
        TicketTypePage,
        TicketComponent,
        TmObjectTicketsComponent,
        TmActiveTicketComponent,
        TmTicketWfProcessStepActivityComponent,
        TmTicketAppointmentInlineComponent,
        MvsCreateObjectTicketComponent,
        TmTicketActionsComponent,
        CreateTmTicketActionsComponent,
        TmTicketSelectPredefinedTaskComponent,
        TicketHistoryComponent,
        TicketQuickCreateComponent,
        TicketCompleteFormComponent,
        ObjectTicketGroupFilterComponent,
        TicketManagementComponent,
        TicketFilterGroupListComponent,
        TicketTypeObjectFullComponent,
        TicketTypeObjectSideComponent,
        TicketTypeObjectBaseComponent,
        TmTicketCustomerContactComponent,
        TmTicketCreateConsultantComponent,
        TmTicketConsultantComponent,
        TmMyTicketsComponent,
        TicketsPage,
        TicketCommentPage,
        TmConfigCheckResultComponent,
    ],
    providers: [TM_ENTITY_PROVIDER, TM_TEST_PROVIDERS, ...TM_WF_ACTIVITY_PROVIDER]

})
export class TmModule  implements DynamicModule {

    alias = 'tm';

    constructor(private moduleRegistry: ModuleRegistryService) {
        this.moduleRegistry.registerModule(this);
    }

    getKpiComponent() {
        return TmKpiComponent;
    }

    getStatisticsComponent() {
        return TmStatisticsComponent;
    }

}